var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.breadcrumb),function(ref){
var onClick = ref.onClick;
var label = ref.label;
return _c('li',{class:onClick ? 'pointer' : '',on:{"click":function($event){onClick && onClick.bind(_vm.vm)()}}},[_vm._v(_vm._s(label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd8877c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/di-ding/common/bread-crumb.vue
// module id = null
// module chunks = 